const Diamond = () => (
  <svg width="9" height="9" viewBox="0 0 10 10" className="text-gold/60">
    <rect x="2.2" y="2.2" width="5.6" height="5.6" transform="rotate(45 5 5)" fill="currentColor" />
  </svg>
);

export default function Marquee({ items }) {
  return (
    <div dir="ltr" className="relative overflow-hidden border-y border-gold/15 bg-navy-900/70 py-5" data-testid="trust-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-navy-950 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-navy-950 to-transparent" />
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8 whitespace-nowrap px-8 font-display text-sm font-semibold text-gold/85">
                <Diamond />
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
